import axios from 'axios';

export default {
  custAxios() {
    return axios.create({
      baseURL : process.env.GRADE_API,
      headers : {
        'Access-Control-Allow-Origin' : '*',
        'Content-Type'                : 'application/json',
        'accept-language'             : window.$nuxt.$store.state._core.user.languageId,
        Authorization                 : window?.$nuxt?.$token?.get(),
        'x-user-timezone'             : window.$nuxt?.$store?.state?._core?.user?.timezone || 'America/Sao_Paulo'
      }
    });
  }
};
